import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ActionButton from "components/ActionButton";

const DataSetupCardHeader = ({
  iconSrc,
  title,
  subtitle,
  actionIconSrc,
  actionText,
  onAddClick,
  secondaryActionIconSrc,
  secondaryActionText,
  onSecondaryActionClick,
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <Stack
      spacing={2}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        pb: 2,
        borderBottom: `1px solid ${
          isDark ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.06)"
        }`,
      }}
    >
      {/* Left section */}
      <Stack spacing={1.5} direction="row" alignItems="center">
        <Box
          sx={{
            borderRadius: "12px",
            width: 48,
            height: 48,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            background: isDark
              ? `linear-gradient(135deg, ${theme.palette.primary.main}25 0%, ${theme.palette.secondary.main}20 100%)`
              : `linear-gradient(135deg, ${theme.palette.primary.main}15 0%, ${theme.palette.secondary.main}12 100%)`,
            boxShadow: isDark
              ? `0 4px 12px ${theme.palette.primary.main}30`
              : `0 4px 12px ${theme.palette.primary.main}20`,
          }}
        >
          <Box
            component="img"
            src={iconSrc}
            alt="Icon"
            sx={{
              width: 28,
              height: 28,
              objectFit: "contain",
            }}
          />
        </Box>

        <Stack>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              background: isDark
                ? `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.secondary.light} 100%)`
                : `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
              fontSize: "1.15rem",
            }}
          >
            {title}
          </Typography>

          {subtitle && (
            <Typography
              variant="body2"
              sx={{
                fontWeight: 500,
                color: theme.palette.text.secondary,
                fontSize: "0.875rem",
              }}
            >
              {subtitle}
            </Typography>
          )}
        </Stack>
      </Stack>
      <Stack spacing={2} direction="row" alignItems="center">
        {/* Right section (Action) */}
        {secondaryActionIconSrc && secondaryActionText && (
          <ActionButton
            iconSrc={secondaryActionIconSrc}
            text={secondaryActionText}
            onClick={onSecondaryActionClick}
          />
        )}
        {/* Right section (Action) */}
        {actionIconSrc && actionText && (
          <ActionButton
            iconSrc={actionIconSrc}
            text={actionText}
            onClick={onAddClick}
          />
        )}
      </Stack>
    </Stack>
  );
};

export default DataSetupCardHeader;
